import { initI18n } from '@bluecodecom/common/i18n';

export const RESOURCES = {
  en: {
    translation: {},
  },
  de: {
    translation: {},
  },
  it: {
    translation: {},
  },
} as const;

initI18n(RESOURCES, {
  interpolation: {
    escapeValue: false,
  },
});
